<template>
  <div id="home">
    <div style="background-color: white; margin: 1rem 2rem">
      <div class="pos_container_panel">
        <!--search area-->
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="padding-top: 1rem"
          :label-width="LabelWidth"
        >
          <el-row style="">
            <el-col :span="12">
              <el-form-item label="客户名称">
                <el-input
                  v-model="searchForm.customerName"
                  @click="showClientNamePop"
                  class="searchInput"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单号">
                <el-input
                  v-model="searchForm.orderNo"
                  class="searchInput"
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
          <el-row style="">
            <el-col :span="12"
              ><div class="grid-content bg-purple">
                <el-form-item label="频道">
                  <el-select v-model="searchForm.proType" class="searchInput">
                    <el-option
                      v-for="item in proType"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item></div
            ></el-col>
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                <el-form-item label="手机号">
                  <el-input
                    v-model="searchForm.phone"
                    class="searchInput"
                  ></el-input>
                </el-form-item></div
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="float: right">
              <div class="grid-content bg-purple-light" style="float: right">
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  @click="Search()"
                >
                  搜索</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-form>
        <hr
          style="
            margin: 1rem -14rem 0rem;
            background-color: rgb(241 243 245);
            height: 0.2rem;
            border: none;
          "
        />
        <!--table-->
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 50px"
        >
          <el-table-column
            prop="customName"
            label="客户名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="orderNo"
            label="订单号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="proType"
            label="频道"
            align="center"
            :formatter="ProTypeFormat"
          ></el-table-column>
          <el-table-column
            prop="recivePhone"
            label="收件人手机号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sendType"
            label="发送类型"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sendStatus"
            label="发送状态"
            align="center"
            :formatter="StatusFormat"
          ></el-table-column>
          <el-table-column
            prop="createdDate"
            label="发送时间"
            align="center"
            :formatter="FormatDateTime"
          ></el-table-column>
          <el-table-column label="操作" width="132" align="center">
            <template #default="scope">
              <el-button
                @click="Show(scope.row)"
                type="text"
                size="small"
              >查看内容</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-bottom: 1rem">
          <el-pagination
            class="paginationsty"
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="searchForm.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 子组件确认框  confirmMsg 提示内容-->
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
  </div>
</template>
  
  <script>
import {smsOrderLogList } from "@/api/platformData";
import { hideElement, formatDateTime } from "@/utils/utils.js";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
export default {
  name: "SMSLog",
  components: {
    ConfirmBoxs,
    ClientList,
  },
  data() {
    return {
      clientListFlag: false,
      LabelWidth: "10rem",
      formLabelWidth: "15rem",
      currentPage1: 1,
      pageSize: 15,
      tableData: [],
      searchForm: {
        total: 0,
        customerName: "",
        customerCode: "",
        proType: "",
        phone: "",
        orderNo: "",
      },
      proType: [
        { value: "全部", key: "" },
        { value: "酒店", key: "JD" },
        { value: "火车", key: "HC" },
        { value: "机票", key: "JP" },
      ],
      confirmFlag: false,
      confirmMsg: "",
      confirmIcon: "",
    };
  },
  mounted() {
    //判断来源 CRM、OBT跳转过来隐藏部分元素
    hideElement(this);
  },
  methods: {
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    //搜索button
    async Search(int) {
      let searchparams = {
        params: {
          CustomerCode: this.searchForm.customerCode,
          Type: this.searchForm.proType,
          Phone: this.searchForm.phone,
          OrderNumber: this.searchForm.orderNo,
          page: int ? int : 1,
          per_page: this.pageSize,
        },
      };
      await smsOrderLogList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.currentPage1 = res.data.page;
            this.tableData = res.data.list;
            this.searchForm.total = res.data.total;
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "搜索信息失败，请稍后重试";
            this.deleteFlag = false;
          }
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
    //分页
    handleCurrentChange(val) {
      this.Search(val);
      console.log(`当前页: ${val}`);
    },
    //搜索点击客户名称弹出选择客户
    showClientNamePop() {
      this.isPosAdd = false;
      this.clientListFlag = true;
    },
    //选择客户
    selectClient(item) {
      this.searchForm.customerName = item.customerName;
      this.searchForm.customerCode = item.customerCode;
    },
    ProTypeFormat(value) {
      let arr_value = this.proType.filter((p) => p.key == value.proType.trim());
      if (arr_value.length > 0) {
        return arr_value[0].value;
      }
      return value;
    },
    StatusFormat(value) {
      if (value.sendStatus == 0) {
        return "成功";
      } else {
        return "失败";
      }
    },
    FormatDateTime(value, index) {
      if (index.property == "createdDate") {
        return formatDateTime(value.createdDate,"YYYY-MM-DD HH:mm:ss");
      } else {
        return formatDateTime(value.updateDate,"YYYY-MM-DD HH:mm:ss");
      }
    },
    Show(value) {
      this.confirmFlag = true;
      this.confirmMsg = value.smscontent;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
  },
};
</script>
  
  <style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}
.pos_container_panel {
  padding: 0px 8rem 4rem;
  overflow-x: hidden;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
.searchInput {
  width: 350px;
  height: 32px;
}
.search-input {
  margin-left: 10%;
}

.search-btn {
  margin: 2% 5%;
}

.select-btn {
  color: #fc6640;
  cursor: pointer;
}
/deep/ .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.el-table .diaabledrow {
  background: #f0f9eb;
}
</style>
  